<script setup lang="ts">
import type { IProps } from './career-main-box.types'
defineProps<IProps>()
</script>

<template>
  <div class="ui-box">
    <img
      class="ui-box__image"
      :src="image.src"
      alt=""
      title=""
    >

    <h1 class="ui-box__title">
      {{ title }}
    </h1>

    <hr class="ui-box__line">

    <p
      class="ui-box__description"
      v-html="description"
    />
  </div>
</template>

<style lang="scss" scoped>
.ui-box {
  background-color: $white;
  border-radius: 2.4rem;

  &__image {
    width: 100%;
    border-radius: 2.4rem;
  }

  &__title {
    @include h10;
    padding-top: 3.2rem;
    padding-bottom: 0.8rem;
    color: $text-400;
  }

  &__description {
    @include body-2-medium;
    padding-top: 0.8rem;
    color: $text-400;

    :deep() {
      a {
        color: $purple-400;
      }
    }
  }

  &__line {
    border: solid 1px $gray-300;
  }

  @include atS {
    padding: 3.2rem;

    &__title {
      @include h9;
    }

    &__description {
      padding-top: 2.4rem;
    }
  }
}

</style>
